const c = (i) => {
  const o = (e) => i((a) => ({ ...a, mercadoPago: { ...a.mercadoPago, ...e } }));
  return {
    initialized: !1,
    setInitialized: (e) => o({ initialized: e })
  };
};
export {
  c as createMercadoPagoSlice
};
